import { render, staticRenderFns } from "./MtMaterialsForm.vue?vue&type=template&id=fc4fa4be&"
import script from "./MtMaterialsForm.vue?vue&type=script&lang=js&"
export * from "./MtMaterialsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports